import { useContext } from "react";
import get from "lodash/get";
import { SettingsContext } from "./SettingsContext";

export const useFlagBoxSettings = () => get(useContext(SettingsContext), "hideFlagBox", false);
